import 'flatpickr';

$(document).ready(() => {
  const options = {};

  // Handle options
  if (window.flatpickr) {
    if (window.flatpickr.forbiddenDates) {
      /**
       * This property must follow the format specified in the documentation:
       * - https://chmln.github.io/flatpickr/examples/#disabling-range-s-of-dates
       */
      options.disable = window.flatpickr.forbiddenDates;
    }
  }

  $('.datepicker').flatpickr(options);

  $('.datepicker-range').flatpickr($.extend(options, { minDate: 'today', mode: 'range' }));
});
